import { render, staticRenderFns } from "./CadastrosMensagensLeads.vue?vue&type=template&id=7934a487"
import script from "./CadastrosMensagensLeads.vue?vue&type=script&lang=ts"
export * from "./CadastrosMensagensLeads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports